let countFetch = 0;
let finallyDateCache = "";
let labelCache = "";
class EstimatedArrivalCart extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    const template = document.createElement("template");
    template.innerHTML = `
      <style>
        :host {
          margin-top: 0;
          display: block;
        }
        :host([show="false"]) {
          display: none;
        }
        .estimated-paragraph {
          margin: 0 0 8px;
          line-height: normal;
          font-size: 13px;
          color: #808080;
        }
        .estimated-paragraph span {
          color: #000;
        }
        .estimated-paragraph--small {
          font-size: 12px;
          margin-bottom: 0;
        }
        .estimated-container {
          display: flex;
          flex-direction: column;
        }
        .estimated-container[data-show="false"] {
          display: none;
        }
        .estimated-loading {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .estimated-loading img {
          width: 50px;
          animation-name: rotateLoading;
          animation-duration: 2s;
          animation-iteration-count: infinite;
        }
        .estimated-loading[data-show="false"] {
          display: none;
        }
        @media screen and (max-width: 768px){
          .estimated-paragraph--small {
            font-size: 12px;
          }
        }

        #loading {

          width: 10px;
          height: 10px;
          border: 2px solid #fff;
          border-top-color: #000;
          border-radius: 50%;
          animation: spin 0.7s ease-in-out infinite;
          -webkit-animation: spin 0.7s ease-in-out infinite;
          display: none;
        }
        [data-show="false"] ~ #loading {
          display: inline-block;
        }

        @keyframes spin {
          to { -webkit-transform: rotate(360deg); }
        }

        @-webkit-keyframes spin {
          to { -webkit-transform: rotate(360deg); }
        }
      </style>
      <div data-show="false" class="estimated-container">
        <p class="estimated-paragraph">
          Order within <span data-value="time">10 hours 29 mins</span>, to expect delivery by <span data-value="date">May 8 - 10</span>
        </p>
        <p class="estimated-paragraph estimated-paragraph--small" data-value="description"></p>
      </div>
      <div id="loading"></div>
    `;
    this.shadowRoot.appendChild(template.content.cloneNode(true));

    this.labels = {
      NoForceDDP:
        "All duties and taxes are applied at checkout. You have the option to pay these at checkout, or when the order reaches customs.",
      ForceDDP:
        "All duties and taxes are applied at checkout, and you are required to pay these at checkout in order for the order to go through.",
      HiddenForceDDP:
        "All duties and taxes are included within the product price.",
      PartialForceDDP:
        "All duties are included within the product price, with taxes applied at checkout.",
    };

    // Element references
    this.timeElement = this.shadowRoot.querySelector('[data-value="time"]');
    this.dateElement = this.shadowRoot.querySelector('[data-value="date"]');
    this.descriptionElement = this.shadowRoot.querySelector(
      '[data-value="description"]'
    );
    this.containerElement = this.shadowRoot.querySelector(
      ".estimated-container"
    );

    this.request();
  }

  static get observedAttributes() {
    return ["product", "handle", "show"];
  }

  connectedCallback() {
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 60000); // Update every minute
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  updateCountdown() {
    const now = new Date();

    // Calculate current time in BST
    const nowBST = new Date(
      now.toLocaleString("en-US", { timeZone: "Europe/London" })
    );

    // Set the target time to 13:00 BST
    let targetBST = new Date(nowBST);
    targetBST.setHours(13, 0, 0, 0); // 13:00 BST

    // If it's past 13:00 BST, set the target to the next day
    if (nowBST.getHours() >= 13) {
      targetBST.setDate(targetBST.getDate() + 1);
    }

    const diff = targetBST - nowBST;

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    this.timeElement.textContent = `${hours} hours ${minutes} mins`;
  }

  async getLocation() {
    try {
      const request = await fetch(
        "https://us-central1-functions-358315.cloudfunctions.net/location"
      );
      const response = await request.json();
      return response;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }

  async request() {
    if (countFetch > 0 && labelCache != "" && finallyDateCache != "") {
      this.descriptionElement.innerHTML = labelCache;
      this.dateElement.innerHTML = finallyDateCache;
      this.containerElement.setAttribute("data-show", true);
      return;
    }

    try {
      const location = await this.getLocation();
      if (undefined === location) return false;

      const request = await fetch(
        "https://webhooks.endrock.software/endrockapi/app/daughter/estimatedArrival",
        {
          method: "POST",
          body: JSON.stringify(location),
        }
      );

      const response = await request.json();
      const {
        data: {
          delivery_max_date_end_at_desc_m,
          delivery_max_date_start_at_desc_m,
          force_ddp,
        },
      } = response;

      const splitStart = delivery_max_date_start_at_desc_m.split(" ");
      const splitEnd = delivery_max_date_end_at_desc_m.split(" ");
      let finallyDate = `${delivery_max_date_start_at_desc_m} - ${delivery_max_date_end_at_desc_m}`;
      if (splitStart[0] == splitEnd[0]) {
        finallyDate = `${splitStart[0]} ${splitStart[1]} - ${splitEnd[1]}`;
      }
      this.dateElement.innerHTML = finallyDate;
      finallyDateCache = finallyDate;
      if (undefined === this.labels[force_ddp]) {
        this.descriptionElement.remove();
      } else {
        this.descriptionElement.innerHTML = this.labels[force_ddp];
        labelCache = this.labels[force_ddp];
      }
      this.containerElement.setAttribute("data-show", true);
      countFetch = countFetch + 1;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }
}

window.customElements.define("estimated-arrival-cart", EstimatedArrivalCart);
